import type { QueueAction } from "./db";
import type { FixtureDescriptor } from "./fixtures";

/**
 * Restore persisted skips without hiding a PR after GitHub reports a new head.
 * Records written before head scoping existed remain effective until the user
 * explicitly chooses "Bring skipped PRs back".
 */
export function skippedFixtureIdsForCurrentHeads(
  fixtures: FixtureDescriptor[],
  actions: QueueAction[],
): Set<string> {
  const currentHeads = new Map(fixtures.map((fixture) => [fixture.id, fixture.headSha]));
  return new Set(actions.flatMap((action) => {
    if (action.type !== "skip" || !currentHeads.has(action.fixtureId)) return [];
    const currentHead = currentHeads.get(action.fixtureId);
    return !action.headSha || !currentHead || action.headSha === currentHead ? [action.fixtureId] : [];
  }));
}
